import { render, staticRenderFns } from "./PaymentDetailsModal.vue?vue&type=template&id=7894728a&scoped=true&"
import script from "./PaymentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailsModal.vue?vue&type=style&index=0&id=7894728a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7894728a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7894728a')) {
      api.createRecord('7894728a', component.options)
    } else {
      api.reload('7894728a', component.options)
    }
    module.hot.accept("./PaymentDetailsModal.vue?vue&type=template&id=7894728a&scoped=true&", function () {
      api.rerender('7894728a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/accounting/PaymentDetailsModal.vue"
export default component.exports